import abilities from '@/plugins/permissions/abilities'
import configApp from '@/config'
import defaultLicense from '@/plugins/permissions/license/default-license'
import defaultResources from '@/plugins/permissions/license/default-resources'
import initial from '@/plugins/permissions/abilities/initial'
import permissions from '@/plugins/permissions'
import router from '@/router'
import store from '@/store'
import Vue from 'vue'
const moment = require('moment')

let auth = new Vue({
  data () {
    return {
      abilities: ['superadministrador', 'administrador', 'profesor', 'instructor', 'desactivado'],

      filter: {
        actores: [5, 2, 1, 7]
      }
    }
  },

  methods: {
    handleAuthentication (cognito) {
      let beforeExpiration = cognito.authentication.ExpiresIn * 1000 - 600000
      setTimeout(() => { this.createUsuarioRefreshToken() }, beforeExpiration)
      this.storeSession(cognito)
      this.readUsuario(cognito)
    },

    isAcademyAuthenticated () {
      let currentAcademy = JSON.parse(localStorage.getItem('current_academy'))
      let currentResources = JSON.parse(localStorage.getItem('current_resources'))
      let storedAcademy = store.getters.getAcademyData
      if (Object.keys(storedAcademy).length === 0) {
        store.commit('setAcademyData', currentAcademy)
        storedAcademy = store.getters.getAcademyData
        permissions.update([...abilities[currentAcademy.current_ability]])
        store.commit('setAcademyResources', currentResources)
      }
      return storedAcademy
    },

    isUserAuthenticated () {
      let fecha = moment().valueOf()
      let expiresAt = localStorage.getItem('expires_at')
      let accessToken = localStorage.getItem('access_token')
      let storedToken = store.getters.getToken
      let user = JSON.parse(localStorage.getItem('user'))
      if (storedToken === '' && accessToken !== null && fecha < expiresAt) {
        store.commit('setSession', {
          userdata: user,
          token: accessToken
        })
        storedToken = store.getters.getToken
        let beforeExpiration = moment(JSON.parse(expiresAt)).diff(fecha, 'milliseconds') - 600000
        setTimeout(() => { this.createUsuarioRefreshToken() }, beforeExpiration)
      }
      let consistentTokens = storedToken === accessToken
      return storedToken !== '' & accessToken !== null && consistentTokens && fecha < expiresAt
    },

    login () {
      localStorage.setItem('current_url', window.location.pathname)
      router.push({ name: 'userLogin' })
    },

    logout () {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('current_resources')
        localStorage.removeItem('current_academy')
        localStorage.removeItem('current_url')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('id_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('user')
        store.commit('unsetSession')
        store.commit('unsetAcademyData')
        store.commit('unsetAcademyDaysLeft')
        permissions.update([...initial])
        this.login()
      })
    },

    readAcademiaRecursosUsados (academia) {
      this.$services.read('academia', 'readAcademiaRecursosUsados', {}, [academia.id])
        .then(response => {
          localStorage.setItem('current_resources', JSON.stringify(response.data))
          store.commit('setAcademyResources', response.data)
          store.commit('setAcademyShowHeaderMessage', true)
        })
        .catch(error => {
          console.log(error)
          this.logout()
        })
    },

    createUsuarioRefreshToken () {
      let storedUser = Object.assign({}, store.getters.getUserData)
      let refreshToken = storedUser.authentication.RefreshToken
      this.$services.create('usuario', 'createUsuarioRefreshToken', { refresh_token: refreshToken })
        .then(response => {
          storedUser.authentication.AccessToken = response.data.authentication.AccessToken
          storedUser.authentication.ExpiresIn = response.data.authentication.ExpiresIn
          storedUser.authentication.IdToken = response.data.authentication.IdToken
          storedUser.authentication.TokenType = response.data.authentication.TokenType
          let beforeExpiration = storedUser.authentication.ExpiresIn * 1000 - 600000
          setTimeout(() => { this.createUsuarioRefreshToken() }, beforeExpiration)
          this.storeSession(storedUser)
        })
        .catch(error => {
          console.log(error)
          this.logout()
        })
    },

    readUsuario (cognito) {
      this.$services.read('usuario', 'readUsuario')
        .then(response => {
          if (response.status === 200 && response.data.email === cognito.email) {
            let storedUser = Object.assign({}, store.getters.getUserData)
            storedUser.vidroop_data = Object.assign({}, response.data)
            localStorage.setItem('user', JSON.stringify(storedUser))
            store.commit('setUserData', storedUser)
            router.push({ name: 'initialAccess' })
          } else {
            this.logout()
          }
        })
        .catch(error => {
          console.log(error)
          this.logout()
        })
    },

    setCurrentAcademy (currentAcademy) {
      let desactivado = false
      for (let [index, tipo] of this.filter.actores.entries()) {
        if (currentAcademy.actores.find(actor => actor.tipo === tipo)) {
          // Condición necesaria ya que la academia de vidroop no posee licencia tanto en dev, test y prod
          if (currentAcademy.licencia && currentAcademy.licencia.id) {
            this.readAcademiaRecursosUsados(currentAcademy)
            if (!currentAcademy.licencia.activa && (tipo === 5 || tipo === 2)) {
              desactivado = true
            }
          } else if (currentAcademy.id === configApp.vidroopAcademyId) {
            currentAcademy.licencia = Object.assign({}, defaultLicense)
            localStorage.setItem('current_resources', JSON.stringify(defaultResources))
            store.commit('setAcademyResources', defaultResources)
          }

          // Esta condición permite asignar el nuevo grupo de permisos 'desactivado' para evitar el uso de la plataforma con lic desactivada
          if (desactivado) {
            permissions.update([...abilities[this.abilities[4]]])
            currentAcademy.current_ability = this.abilities[4]
          } else {
            permissions.update([...abilities[this.abilities[index]]])
            currentAcademy.current_ability = this.abilities[index]
          }
          break
        }
      }
      localStorage.setItem('current_academy', JSON.stringify(currentAcademy))
      store.commit('setAcademyData', currentAcademy)
    },

    storeSession (cognito) {
      let expiresAt = moment().add(cognito.authentication.ExpiresIn * 1000, 'milliseconds').valueOf()
      localStorage.setItem('expires_at', expiresAt)
      localStorage.setItem('access_token', cognito.authentication.AccessToken)
      localStorage.setItem('id_token', cognito.authentication.IdToken)
      localStorage.setItem('refresh_token', cognito.authentication.RefreshToken)
      localStorage.setItem('user', JSON.stringify(cognito))
      store.commit('setSession', {
        userdata: cognito,
        token: cognito.authentication.AccessToken
      })
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$auth = auth
  }
}
